import React, { useState, useEffect } from 'react';
import { AiOutlineFileText } from "react-icons/ai";
import { useFormik } from 'formik';
import { AddTrainingSchema } from './CourseManagementSchema';
import Select from 'react-select'
import { useDispatch, useSelector } from 'react-redux';
import { venueListRes, venueListTodo } from '../../LMS_Redux/LMS_Slices/Masters/VenueList';
import DataTables from '../LMS_DATA_TABLE/DataTable';
import PropagateLoader from "react-spinners/PropagateLoader";
import { userListRes, userListTodo } from '../../LMS_Redux/LMS_Slices/Masters/UserList';
import { courseListTodo } from '../../LMS_Redux/LMS_Slices/Course/CourseList';
// import { groupListTodo } from '../../LMS_Redux/LMS_Slices/Masters/GroupList';
// import { departmentListTodo } from '../../LMS_Redux/LMS_Slices/Assets/DepartmentList';
// import { getUserWiseTodo } from '../../LMS_Redux/LMS_Slices/Assets/GetUserWise';
import { instructorListTodo } from '../../LMS_Redux/LMS_Slices/Assets/InstructorList';
import { learningTrackListTodo } from '../../LMS_Redux/LMS_Slices/Course/LearningTrackList';
import { addTrainingRes, addTrainingTodo } from '../../LMS_Redux/LMS_Slices/Course/AddTraining';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import { trainingTypeTodo } from '../../LMS_Redux/LMS_Slices/Course/TrainingType';
import { Spinner } from 'react-bootstrap';
import { userListByCourseRes, userListByCourseTodo } from '../../LMS_Redux/LMS_Slices/Course/UserListByCourse';

export default function AddTraining() {

    const navigate = useNavigate()
    const dispatch = useDispatch()
    const venue = useSelector(state => state.venueList && state.venueList.data && state.venueList.data.data)
    const instructor = useSelector(state => state.instructorList && state.instructorList.data && state.instructorList.data.data)
    const course = useSelector(state => state.courseList && state.courseList.data && state.courseList.data.data)
    const track = useSelector(state => state.learningTrackList && state.learningTrackList.data && state.learningTrackList.data.data)
    // const group = useSelector(state => state.groupList && state.groupList.data && state.groupList.data.data)
    // const department = useSelector(state => state.depratmentList && state.depratmentList.data && state.depratmentList.data.data)
    const training_type = useSelector(state => state.trainingType && state.trainingType.data && state.trainingType.data.data)
    const user_list = useSelector(state => state.userList && state.userList.data && state.userList.data.data)
    const user_list_course = useSelector(state => state.userListByCourse && state.userListByCourse.data && state.userListByCourse.data.data)
    const [loading, setLoading] = useState(false)
    const [userLoading, setUserLoading] = useState(false)
    const [spinner, setSpinner] = useState(false)
    // console.log(user_list)

    const userRole = JSON.parse(localStorage.getItem('user_data'));
    const role = userRole && userRole.vrole_name
    const roleCode = userRole && userRole.vemp_code

    const venue_list = []
    const course_list = []
    const track_list = []
    // const group_list = []
    // const department_list = []
    const instructor_list = []

    const venue_option = venue && venue.map((value) => venue_list.push({
        "value": value.id,
        "label": value.venue_name
    }))

    const course_option = course && course.map((value) => course_list.push({
        "value": value.id,
        "label": value.course_title
    }))

    const training_type_option = training_type && training_type.map(val => (
        { "value": val.id, "label": val.training_type_title }
    ))

    // const group_option = group && group.map((value) => group_list.push({
    //     "value": value.id,
    //     "label": value.group_name
    // }))

    // const department_option = department && department.map((value) => department_list.push({
    //     "value": value.did,
    //     "label": value.vdepartment_name
    // }))

    const track_option = track && track.map((value) => track_list.push({
        "value": value.id,
        "label": value.learning_title
    }))

    const instructor_option = instructor && instructor.map((value) => instructor_list.push({
        "value": value.vemp_code,
        "label": value.vemp_fname
    }))

    const initialValues = {
        training_title: '',
        training_mode: '',
        classroom_type: '',
        venue: '',
        instructor_name: role === "Instructor" ? roleCode : '',
        start_date: '',
        start_time: '',
        end_date: '',
        end_time: '',
        type: '',
        learning_track: '',
        course_wise: [],
        employee: [],
        link: '',
        meeting: '',
        password: '',
        title: '',
        training_type: '',
        repetation: '',
        repeat_count: '',
        interval_count: '',
        // filter_source: 'user',
        // filter_group: '',
        // filter_department: [],
    };

    const { values, errors, touched, handleBlur, handleChange, handleSubmit, setFieldValue } = useFormik({
        initialValues: initialValues,
        validationSchema: AddTrainingSchema,
        enableReinitialize: true,

        onSubmit: (values, action) => {
            // console.log("new", values)
            setSpinner(true)
            dispatch(addTrainingTodo(values)).then(() => add_update_res(action))
        },
    })

    const add_update_res = (action) => {
        // console.log(addUpdateCourseRes)
        if (addTrainingRes && addTrainingRes.success) {

            action.resetForm()

            // selectInputRef_department.current.setValue([])
            // selectInputRef_quiz.current.clearValue()
            setSpinner(false)
            toast.success(addTrainingRes.message, { position: "bottom-right" })
            setTimeout(() => {
                navigate('/training_list')
            }, 2000);

        } else {
            setSpinner(false)
            toast.error(addTrainingRes.message, { position: "bottom-right" })
        }
    }

    const [columnDefs, setColumnDefs] = useState([
        {
            headerName: 'NAME',
            field: 'vemp_fname',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
            headerCheckboxSelection: true,
            checkboxSelection: true,
            headerCheckboxSelectionFilteredOnly: true,
            width: 300
        },
        {
            headerName: 'ID',
            field: 'vemp_company_code',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'GROUP',
            field: 'group_ids',
            valueFormatter: function (params) {
                return params.data.group_ids.map(val => `${val.group_name}`).join(',')
            },
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            sortable: true,
            floatingFilter: true,
            wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'DEPARTMENT',
            field: 'vdepartment_name',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'DESIGNATION',
            field: 'vdesignation_name',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'EMAIL',
            field: 'vemail',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'PHONE NO.',
            field: 'vmobile_no',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
    ]);

    // const reset_filter = () => {
    //     setFieldValue("filter_group", '');
    //     setFieldValue("filter_department", []);
    //     // setLoading(true)
    //     // dispatch(getUserWiseTodo({ "group_data": [], "department_data": [] })).then(() => user_list_res())
    // }

    const reset_type = () => {
        setFieldValue("learning_track", '');
        setFieldValue("course_wise", []);
    }

    // const user_wise = (option, destinaion) => {
    //     if (destinaion == 'group') {
    //         setLoading(true)
    //         dispatch(getUserWiseTodo({ "group_data": [option], "department_data": [] })).then(() => user_list_res())
    //     } else if (destinaion == 'department') {
    //         setLoading(true)
    //         dispatch(getUserWiseTodo({ "group_data": [], "department_data": option })).then(() => user_list_res())
    //     }
    // }

    const course_user_list = (data, param) => {
        if (param == 'track') {
            setFieldValue('employee', [])
            setUserLoading(true)
            dispatch(userListByCourseTodo({ "course": [], "track": data, "role": "GRD/2", "instructor": values.instructor_name, "start_date": values.start_date, "start_time": values.start_time, "end_date": values.end_date, "end_time": values.end_time })).then(() => user_list_res())
        } else if (param == 'course') {
            setFieldValue('employee', [])
            setUserLoading(true)
            dispatch(userListByCourseTodo({ "course": data, "track": '', "role": "GRD/2", "instructor": values.instructor_name, "start_date": values.start_date, "start_time": values.start_time, "end_date": values.end_date, "end_time": values.end_time })).then(() => user_list_res())
        } else if (param == 'start_date') {
            setFieldValue('employee', [])
            setUserLoading(true)
            dispatch(userListByCourseTodo({ "course": values.course_wise, "track": values.learning_track, "role": "GRD/2", "instructor": values.instructor_name, "start_date": data, "start_time": values.start_time, "end_date": values.end_date, "end_time": values.end_time })).then(() => user_list_res())
        } else if (param == 'start_time') {
            setFieldValue('employee', [])
            setUserLoading(true)
            dispatch(userListByCourseTodo({ "course": values.course_wise, "track": values.learning_track, "role": "GRD/2", "instructor": values.instructor_name, "start_date": values.start_date, "start_time": data, "end_date": values.end_date, "end_time": values.end_time })).then(() => user_list_res())
        } else if (param == 'end_date') {
            setFieldValue('employee', [])
            setUserLoading(true)
            dispatch(userListByCourseTodo({ "course": values.course_wise, "track": values.learning_track, "role": "GRD/2", "instructor": values.instructor_name, "start_date": values.start_date, "start_time": values.start_time, "end_date": data, "end_time": values.end_time })).then(() => user_list_res())
        } else if (param == 'end_time') {
            setFieldValue('employee', [])
            setUserLoading(true)
            dispatch(userListByCourseTodo({ "course": values.course_wise, "track": values.learning_track, "role": "GRD/2", "instructor": values.instructor_name, "start_date": values.start_date, "start_time": values.start_time, "end_date": values.end_date, "end_time": data })).then(() => user_list_res())
        }
    }

    const instructor_user_list = (data) => {
        setFieldValue('employee', [])
        setUserLoading(true)
        dispatch(userListByCourseTodo({ "course": values.course_wise, "track": values.learning_track, "role": "GRD/2", "instructor": data, "start_date": values.start_date, "start_time": values.start_time, "end_date": values.end_date, "end_time": values.end_time })).then(() => user_list_res())
    }

    const user_list_res = () => {
        if (userListByCourseRes && userListByCourseRes.success) {
            setUserLoading(false)
        } else {
            setUserLoading(false)
        }
    }

    const interval_check = (type) => {
        if (type == 'virtual') {
            setFieldValue('repetation', 'no_repeat')
        } else {
            setFieldValue('repetation', '')
        }
    }

    const venue_res = async () => {
        try {
            if (venueListRes && venueListRes.success) {
                await Promise.all([
                    dispatch(instructorListTodo()),
                    dispatch(courseListTodo({ "temp": '', "course_availability": 'public', "course_type": 'general' })),
                    dispatch(learningTrackListTodo({ "temp": "" })),
                    dispatch(trainingTypeTodo()),
                ]);
                setLoading(false);
            } else {
                setLoading(false)
            }
        } catch (error) {
            setLoading(false)
        }
    }

    useEffect(() => {
        setLoading(true)
        dispatch(venueListTodo({ "status": 'active', "temp": '' })).then(() => venue_res())

        // dispatch(groupListTodo({ "status": '' }))
        // dispatch(departmentListTodo())

        // dispatch(userListTodo({ "role": "GRD/2" })).then(() => user_list_res())
    }, [])

    return (
        <>
            <div className='container-fluid'>
                <div className='scnd-header'>
                    <span className='icon1'>Learning Module Management / </span>
                    <span className='icon2'>Add Session</span>
                </div>

                <div className='wrapper-admin'>
                    {loading ?
                        <div className='text-center mb-3'>
                            <PropagateLoader
                                color="#2262C6"
                                size={20}
                            />
                        </div>
                        :
                        <form onSubmit={(e) => { e.preventDefault(); handleSubmit(); }} method='post'>
                            <div className="row">

                                <div className="col-12 col-md-3">
                                    <div className="mb-3">
                                        <label htmlFor="" className="form-label form_label">Training Mode</label>
                                        <select className="form-select form_input"
                                            name='training_mode' value={values.training_mode}
                                            onChange={(e) => {
                                                handleChange(e);
                                                setFieldValue("classroom_type", '');
                                                setFieldValue("venue", '');
                                                setFieldValue("link", '');
                                                setFieldValue("meeting", '');
                                                setFieldValue("password", '');
                                                setFieldValue("title", '');
                                                setFieldValue("start_date", '');
                                                setFieldValue("start_time", '');
                                                setFieldValue("end_date", '');
                                                setFieldValue("end_time", '');
                                                interval_check(e.target.value)
                                            }}
                                            onBlur={handleBlur}
                                        >
                                            <option value="">Select</option>
                                            <option value="classroom">Classroom</option>
                                            <option value="virtual">Virtual</option>
                                        </select>
                                        {errors.training_mode && touched.training_mode ? (<span className='text-danger form_label'>{errors.training_mode}</span>) : null}
                                    </div>
                                </div>

                                {values.training_mode == 'classroom' ?
                                    <div className="col-12 col-md-3">
                                        <div className="mb-3">
                                            <label htmlFor="" className="form-label form_label">Classroom Type</label>
                                            <select className="form-select form_input"
                                                name='classroom_type' value={values.classroom_type}
                                                onChange={(e) => {
                                                    handleChange(e);
                                                    setFieldValue("venue", '');
                                                    setFieldValue("link", '');
                                                    setFieldValue("meeting", '');
                                                    setFieldValue("password", '');
                                                    setFieldValue("title", '');
                                                }}
                                                onBlur={handleBlur}
                                            >
                                                <option value="">Select</option>
                                                <option value="physical">Physical</option>
                                                <option value="live">Live</option>
                                            </select>
                                            {errors.classroom_type && touched.classroom_type ? (<span className='text-danger form_label'>{errors.classroom_type}</span>) : null}
                                        </div>
                                    </div>
                                    : ''
                                }

                                {values.classroom_type == 'physical' ?
                                    <div className="col-12 col-md-3">
                                        <div className="mb-3">
                                            <label htmlFor="" className="form-label form_label">Venue</label>
                                            <Select
                                                // ref={selectInputRef_quiz}
                                                closeMenuOnSelect={true}
                                                options={venue_list}
                                                // defaultValue={state ? data && quiz_option.find((option) => option.value == data.lms_course_quizzes.quiz_id) : ''}
                                                onChange={(e) =>
                                                    // console.log(e)
                                                    setFieldValue('venue', e && e.value || '')
                                                }
                                                onBlur={handleBlur}
                                                name='venue'
                                                // isMulti
                                                placeholder="Select Venue"
                                                classNamePrefix="select"
                                            />
                                            {errors.venue && touched.venue ? (<span className='text-danger form_label'>{errors.venue}</span>) : null}
                                        </div>
                                    </div>
                                    : ''
                                }

                                <div className="col-12 col-md-3">
                                    <div className="mb-3">
                                        <label htmlFor="" className="form-label form_label">Instructor Name</label>
                                        <Select
                                            // ref={selectInputRef_quiz}
                                            closeMenuOnSelect={true}
                                            options={instructor_list}
                                            defaultValue={role === "Instructor" ? instructor_list.find((option) => option.value == roleCode) : ''}
                                            isDisabled={role === "Instructor" ? true : false}
                                            onChange={(e) => {
                                                // console.log(e)
                                                setFieldValue('instructor_name', e && e.value || '')
                                                instructor_user_list(e?.value)
                                            }}
                                            onBlur={handleBlur}
                                            name='instructor_name'
                                            // isMulti
                                            placeholder="Select Instructor"
                                            classNamePrefix="select"
                                        />
                                        {errors.instructor_name && touched.instructor_name ? (<span className='text-danger form_label'>{errors.instructor_name}</span>) : null}
                                    </div>
                                </div>
                            </div>
                            <div className='row'>

                                <div className="col-12 col-md-3">
                                    <div className="mb-3">
                                        <label htmlFor="" className="form-label form_label">Training Title</label>
                                        <input type="text" className="form_input form-control" placeholder="Training Title"
                                            name='training_title' value={values.training_title || ''} onChange={handleChange} onBlur={handleBlur}
                                        />
                                        {errors.training_title && touched.training_title ? (<span className='text-danger form_label'>{errors.training_title}</span>) : null}
                                    </div>
                                </div>

                                <div className="col-12 col-md-3">
                                    <div className="mb-3">
                                        <label htmlFor="" className="form-label form_label">Training Type</label>
                                        <Select
                                            closeMenuOnSelect={true}
                                            options={training_type_option}
                                            onChange={(option) =>
                                                setFieldValue('training_type', option && option.value || '')
                                            }
                                            onBlur={handleBlur}
                                            name='training_type'
                                            // isMulti
                                            placeholder="Select Training Type"
                                            classNamePrefix="select"
                                        />
                                        {errors.training_type && touched.training_type ? (<span className='text-danger form_label'>{errors.training_type}</span>) : null}
                                    </div>
                                </div>

                                {values.instructor_name == '' ? '' :
                                    <div className="col-12 col-md-3">
                                        <div className="mb-3">
                                            <label htmlFor="" className="form-label form_label">Add Learning Module</label>
                                            <select className="form-select form_input"
                                                name='type' value={values.type} onChange={(e) => { handleChange(e); reset_type() }} onBlur={handleBlur}
                                            >
                                                <option value="">Select</option>
                                                <option value="Learning Path">Learning Track</option>
                                                <option value="Course Wise">Learning Module Wise</option>
                                            </select>
                                            {errors.type && touched.type ? (<span className='text-danger form_label'>{errors.type}</span>) : null}
                                        </div>
                                    </div>
                                }

                                {values.type == 'Learning Path' ?
                                    <div className="col-12 col-md-3">
                                        <div className="mb-3">
                                            <label htmlFor="" className="form-label form_label">Add Learning Track</label>
                                            <Select
                                                closeMenuOnSelect={true}
                                                options={track_list}
                                                // value={values.learning_track}
                                                onChange={(option) => {
                                                    setFieldValue('learning_track', option && option.value || '');
                                                    course_user_list(option?.value, 'track')
                                                }}
                                                onBlur={handleBlur}
                                                name='learning_track'
                                                // isMulti
                                                placeholder="Select Learning Track"
                                                classNamePrefix="select"
                                            />
                                            {errors.learning_track && touched.learning_track ? (<span className='text-danger form_label'>{errors.learning_track}</span>) : null}
                                        </div>
                                    </div>
                                    : ''
                                }

                                {values.type == 'Course Wise' ?
                                    <div className="col-12 col-md-3">
                                        <div className="mb-3">
                                            <label htmlFor="" className="form-label form_label">Learning Module List</label>
                                            <Select
                                                closeMenuOnSelect={false}
                                                options={course_list}
                                                // value={values.course_wise}
                                                onChange={(option) => {
                                                    setFieldValue('course_wise', option);
                                                    course_user_list(option, 'course')
                                                }}
                                                onBlur={handleBlur}
                                                name='course_wise'
                                                isMulti
                                                placeholder="Select Learning Module"
                                                classNamePrefix="select"
                                            />
                                            {errors.course_wise && touched.course_wise ? (<span className='text-danger form_label'>{errors.course_wise}</span>) : null}
                                        </div>
                                    </div>
                                    : ''
                                }

                                {values?.training_mode == 'classroom' &&
                                    <h6 className=''>
                                        Session Interval
                                    </h6>
                                }

                                {values?.training_mode == 'classroom' &&
                                    <div className="col-12 col-md-4">
                                        <div className="mb-3">
                                            <label htmlFor="" className="form-label form_label">Repetation</label>
                                            <select className="form-select form_input"
                                                name='repetation' value={values.repetation}
                                                onChange={(e) => {
                                                    handleChange(e);
                                                    setFieldValue("repeat_count", '');
                                                    setFieldValue("interval_count", '');
                                                }}
                                                onBlur={handleBlur}
                                            >
                                                <option value="">Select</option>
                                                <option value="repeat">Repeat</option>
                                                <option value="no_repeat">No Repeat</option>
                                            </select>
                                            {errors.repetation && touched.repetation ? (<span className='text-danger form_label'>{errors.repetation}</span>) : null}
                                        </div>
                                    </div>
                                }

                                {values.repetation == 'repeat' ?
                                    <div className="col-12 col-md-4">
                                        <div className="mb-3">
                                            <label htmlFor="" className="form-label form_label">Interval (In Days)</label>
                                            <input type="number" className="form_input form-control" placeholder="Interval (In Days)"
                                                name='interval_count' value={values.interval_count || ''} onChange={handleChange} onBlur={handleBlur}
                                            />
                                            {errors.interval_count && touched.interval_count ? (<span className='text-danger form_label'>{errors.interval_count}</span>) : null}
                                        </div>
                                    </div>
                                    : ''
                                }

                                {values.repetation == 'repeat' ?
                                    <div className="col-12 col-md-4">
                                        <div className="mb-3">
                                            <label htmlFor="" className="form-label form_label">Repeat</label>
                                            <input type="number" className="form_input form-control" placeholder="Repeat"
                                                name='repeat_count' value={values.repeat_count || ''} onChange={handleChange} onBlur={handleBlur}
                                            />
                                            {errors.repeat_count && touched.repeat_count ? (<span className='text-danger form_label'>{errors.repeat_count}</span>) : null}
                                        </div>
                                    </div>
                                    : ''
                                }

                                {values.training_mode == 'classroom' &&
                                    <h6 className=''>
                                        Schedule
                                    </h6>
                                }

                                {values.training_mode == 'classroom' ?
                                    <div className="col-12 col-md-3">
                                        <div className="mb-3">
                                            <label htmlFor="" className="form-label form_label">Start Date</label>
                                            <input type="date" className="form-control form_input"
                                                name='start_date' value={values.start_date} onChange={(e) => { handleChange(e); course_user_list(e?.target?.value, 'start_date') }} onBlur={handleBlur}
                                                min={new Date().toISOString().split('T')[0]}
                                            />
                                            {errors.start_date && touched.start_date ? (<span className='text-danger form_label'>{errors.start_date}</span>) : null}
                                        </div>
                                    </div>
                                    : ''
                                }

                                {values.training_mode == 'classroom' ?
                                    <div className="col-12 col-md-3">
                                        <div className="mb-3">
                                            <label htmlFor="" className="form-label form_label">Start Time</label>
                                            <input type="time" className="form-control form_input"
                                                name='start_time' value={values.start_time} onChange={(e) => { handleChange(e); course_user_list(e?.target?.value, 'start_time') }} onBlur={handleBlur}
                                            />
                                            {errors.start_time && touched.start_time ? (<span className='text-danger form_label'>{errors.start_time}</span>) : null}
                                        </div>
                                    </div>
                                    : ''
                                }

                                {values.training_mode == 'classroom' ?
                                    <div className="col-12 col-md-3">
                                        <div className="mb-3">
                                            <label htmlFor="" className="form-label form_label">End Date</label>
                                            <input type="date" className="form_input form-control"
                                                name='end_date' value={values.end_date} onChange={(e) => { handleChange(e); course_user_list(e?.target?.value, 'end_date') }} onBlur={handleBlur}
                                                min={values.start_date}
                                            />
                                            {errors.end_date && touched.end_date ? (<span className='text-danger form_label'>{errors.end_date}</span>) : null}
                                        </div>
                                    </div>
                                    : ''
                                }

                                {values.training_mode == 'classroom' ?
                                    <div className="col-12 col-md-3">
                                        <div className="mb-3">
                                            <label htmlFor="" className="form-label form_label">End Time</label>
                                            <input type="time" className="form_input form-control"
                                                name='end_time' value={values.end_time} onChange={(e) => { handleChange(e); course_user_list(e?.target?.value, 'end_time') }} onBlur={handleBlur}
                                            />
                                            {errors.end_time && touched.end_time ? (<span className='text-danger form_label'>{errors.end_time}</span>) : null}
                                        </div>
                                    </div>
                                    : ''
                                }

                            </div>

                            {values.classroom_type == 'live' ?
                                <div className='mt-4'>
                                    <div className="row">

                                        <div className='col-12 addcourse_heading'>
                                            <div className='circle'><AiOutlineFileText /></div>
                                            <h6>New Live Session</h6>
                                        </div>

                                        <div className="col-12 col-md-4">
                                            <div className="mb-3">
                                                <label htmlFor="" className="form-label form_label">Insert the link of live session here</label>
                                                <input type="text" className="form_input form-control" placeholder="Insert the link of live session here"
                                                    name='link' value={values.link} onChange={handleChange} onBlur={handleBlur}
                                                />
                                                {errors.link && touched.link ? (<span className='text-danger form_label'>{errors.link}</span>) : null}
                                            </div>
                                        </div>

                                        <div className="col-12 col-md-4">
                                            <div className="mb-3">
                                                <label htmlFor="" className="form-label form_label">Meeting ID</label>
                                                <input type="text" className="form_input form-control" placeholder="Meeting ID"
                                                    name='meeting' value={values.meeting} onChange={handleChange} onBlur={handleBlur}
                                                />
                                                {errors.meeting && touched.meeting ? (<span className='text-danger form_label'>{errors.meeting}</span>) : null}
                                            </div>
                                        </div>

                                        <div className="col-12 col-md-4">
                                            <div className="mb-3">
                                                <label htmlFor="" className="form-label form_label">Password</label>
                                                <input type="password" className="form_input form-control" placeholder="Password"
                                                    name='password' value={values.password} onChange={handleChange} onBlur={handleBlur}
                                                />
                                                {errors.password && touched.password ? (<span className='text-danger form_label'>{errors.password}</span>) : null}
                                            </div>
                                        </div>

                                        <div className="col-12 col-md-4">
                                            <div className="mb-3">
                                                <label htmlFor="" className="form-label form_label">Title</label>
                                                <input type='text' className="form-control form_input" placeholder="Title"
                                                    name='title' value={values.title} onChange={handleChange} onBlur={handleBlur}
                                                />
                                                {errors.title && touched.title ? (<span className='text-danger form_label'>{errors.title}</span>) : null}
                                            </div>
                                        </div>

                                        {/* <div className="col-12 col-md-4">
                                        <div className="mb-3">
                                            <label htmlFor="Date" className="form-label form_label">Date</label>
                                            <input type='date' className="form-control form_input" placeholder="Date" />
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-4">
                                        <div className="mb-3">
                                            <label htmlFor="Date" className="form-label form_label">Duration</label>
                                            <input type='time' className="form-control form_input" placeholder="Duration" />
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-4">
                                        <div className="mb-3">
                                            <label htmlFor="Description" className="form-label form_label">Description</label>
                                            <textarea className="form-control form_input" placeholder="Type Your Description here" />
                                        </div>
                                    </div> */}
                                        {/* <div className="col-12 col-md-5">
                                    <div className="mb-3">
                                        <label htmlFor="Description" className="form-label form_label">Enrollment by Department/Group/User</label>
                                        <select name="" className="form-select form_input">
                                            <option value="">Group</option>
                                            <option value="">Department</option>
                                            <option value="">User</option>
                                        </select>
                                    </div>
                                </div> */}
                                    </div>
                                </div>
                                : ''
                            }

                            <div className='mt-2'>
                                <h6>Enrol Employees to Training</h6>

                                {/* <div className="row">
                                <div className="col-md-4">
                                    <div className="mb-3">
                                        <label htmlFor="Description" className="form-label form_label">Enrollment by Department/Group/User</label>
                                        <select className="form-select form_input"
                                            name="filter_source" value={values.filter_source || ''} onChange={(e) => { handleChange(e); reset_filter() }} onBlur={handleBlur}
                                        >
                                            <option value="">Select</option>
                                            <option value="group">Group</option>
                                            <option value="department">Department</option>
                                            <option value="user">User</option>
                                        </select>
                                        {errors.filter_source && touched.filter_source ? (<span className='text-danger form_label'>{errors.filter_source}</span>) : null}
                                    </div>
                                </div>

                                {values.filter_source == 'group' ?
                                    <div className="col-12 col-md-4">
                                        <div className="mb-3">
                                            <label htmlFor="" className="form-label form_label">Group List</label>
                                            <Select
                                                closeMenuOnSelect={true}
                                                options={group_list}
                                                // value={values.course_wise}
                                                onChange={(option) => {
                                                    setFieldValue('filter_group', option && option.value); user_wise(option, 'group')
                                                }}
                                                onBlur={handleBlur}
                                                name='filter_group'
                                                // isMulti
                                                placeholder="Select Group"
                                                classNamePrefix="select"
                                            />
                                            {errors.filter_group && touched.filter_group ? (<span className='text-danger form_label'>{errors.filter_group}</span>) : null}
                                        </div>
                                    </div>
                                    : ''
                                }

                                {values.filter_source == 'department' ?
                                    <div className="col-12 col-md-4">
                                        <div className="mb-3">
                                            <label htmlFor="" className="form-label form_label">Department List</label>
                                            <Select
                                                closeMenuOnSelect={false}
                                                options={department_list}
                                                // value={values.course_wise}
                                                onChange={(option) => {
                                                    setFieldValue('filter_department', option); user_wise(option, 'department')
                                                }}
                                                onBlur={handleBlur}
                                                name='filter_department'
                                                isMulti
                                                placeholder="Select Department"
                                                classNamePrefix="select"
                                            />
                                            {errors.filter_department && touched.filter_department ? (<span className='text-danger form_label'>{errors.filter_department}</span>) : null}
                                        </div>
                                    </div>
                                    : ''
                                }
                            </div> */}

                                {userLoading ?
                                    <div className='text-center mb-3'>
                                        <PropagateLoader
                                            color="#2262C6"
                                            size={20}
                                        />
                                    </div>
                                    :
                                    <DataTables
                                        rowData={user_list_course}
                                        columnDefs={columnDefs}
                                        selection={true}
                                        value={setFieldValue}
                                        field={"employee"}
                                        check={"multiple"}
                                        // preSelected={test ? test : ''}
                                        addTrainingCheck={true}
                                    />
                                }
                                {errors.employee && touched.employee ? (<span className='text-danger form_label'>{errors.employee}</span>) : null}

                            </div>
                            <div className='text-end mt-4'>
                                <button className='btn btn_submit' type='submit' disabled={spinner ? true : false}>Submit
                                    {spinner ?
                                        <Spinner
                                            as="span"
                                            animation="border"
                                            size="sm"
                                            role="status"
                                            aria-hidden="true"
                                            className='ms-2'
                                        />
                                        : ''
                                    }
                                </button>
                            </div>
                        </form>
                    }
                </div>
            </div>
            <ToastContainer />
        </>
    )
}